<template>
  <div class="br-steps">
    <div
      v-for="(step, index) in steps"
      :key="step.key"
      class="br-steps__item"
      :class="{
        'br-steps__item--active': isStepActive(step.key),
        'br-steps__item--done': stepOrder(currentStep) > index,
        'br-steps__item--rejected': step.key === 'rejected' && isStepActive('rejected'),
      }"
    >
      <div class="br-steps__pill">
        <div class="br-steps__number">{{ index + 1 }}</div>
        <div class="br-steps__name">
          <div class="br-steps__label">{{ $t(step.labelKey) }}</div>
          <div v-if="isStepActive(step.key)" class="br-steps__edit" aria-hidden="true">
            <feather type="chevron-right" :size="25" stroke="currentColor" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrSubmitSteps',
  props: {
    currentStep: {
      type: String,
      default: 'upload',
    },
  },
  computed: {
    steps() {
      const thirdStep = this.currentStep === 'rejected'
        ? { key: 'rejected', labelKey: 'lbl_EMPBE_BR_Step_Rejected' }
        : { key: 'pending', labelKey: 'lbl_EMPBE_BR_Step_Pending' };
      return [
        { key: 'upload', labelKey: 'lbl_EMPBE_BR_Step_Upload' },
        { key: 'confirm', labelKey: 'lbl_EMPBE_BR_Step_Confirm' },
        thirdStep,
      ];
    },
  },
  methods: {
    isStepActive(stepKey) {
      return this.currentStep === stepKey;
    },
    stepOrder(key) {
      return this.steps.findIndex((s) => s.key === key);
    },
  },
};
</script>
